<template>
  <v-card outlined class="pa-6 elevation-2">
    <v-card-title class="headline font-weight-medium">
      Número de recibo
    </v-card-title>
    <v-card-subtitle>
      Ingresa el <strong>número</strong> de su recibo.
    </v-card-subtitle>
    <v-card-text>
      <v-text-field v-model="recibo" label="Número de recibo" placeholder="12345678" :rules="[validarRecibo]"
        v-mask="'##################'" @keyup.enter="buscarRecibo" outlined dense clearable clear-icon="mdi-close-circle"
        persistent-placeholder />

      <v-alert v-if="error" type="error" dense outlined class="mt-4" border="left" colored-border elevation="1">
        {{ error }}
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" block class="mt-4" @click="buscarRecibo">
        <v-icon right>mdi-magnify</v-icon>
        Buscar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      recibo: '',
      error: '',
      detalleRecibo: []
    };
  },
  created(){
        this.recibo = this.$route.params.recibo || ''; // Obtener el ID de la URL
  },
  methods: {
    validarRecibo(valor) {
      return valor && valor.length >= 10 || 'Debe ingresar un mínimo de 10 dígitos';
    },
    buscarRecibo() {
      this.error = '';

      if (!this.recibo || this.recibo.length < 4) {
        this.error = 'Ingrese un número de recibo válido.';
        return;
      }
      this.$http.get(`pagolinea/${this.recibo}`)
        .then(response => {
          if (response.status === 200) {
            this.detalleRecibo = response.data
            // Redirección a la ruta de detalle
            //this.$router.push({ name: 'detalleRecibo', params: { id: this.recibo } });
            this.$router.push({
              name: 'detalleRecibo',
              params: {
                recibo: this.detalleRecibo
              }
            });
          }else{
              this.error = 'Su recibo no fue localizado, intenta nuevamente o ponte en contacto con nosotros';
          }
        })
        .catch((error) => {
          console.error('Error al consultar asistencia:', error)
        });


    }
  }
};
</script>

<style scoped>
.v-card {
  max-width: 400px;
  margin: auto;
}
</style>
